import React, { useState } from 'react';
import { SearchIcon, SendIcon, PaperclipIcon, PhoneIcon, VideoIcon, UserIcon, MoreHorizontalIcon, CheckCircleIcon, ImageIcon, FileIcon, MessageSquareIcon } from 'lucide-react';
// Mock conversation data
const conversations = [{
  id: 1,
  name: 'Victoria Estates',
  avatar: 'https://images.unsplash.com/photo-1560250097-0b93528c311a?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=256&q=80',
  lastMessage: "We've received your payment for the Lekki property.",
  timestamp: '10:23 AM',
  unread: 2,
  isAgent: true,
  isOnline: true
}, {
  id: 2,
  name: 'Johnson & Partners Law Firm',
  avatar: 'https://images.unsplash.com/photo-1568602471122-7832951cc4c5?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=256&q=80',
  lastMessage: 'The property documents have been verified. All looks good!',
  timestamp: 'Yesterday',
  unread: 0,
  isAgent: false,
  isOnline: true
}, {
  id: 3,
  name: 'Luxury Interiors',
  avatar: 'https://images.unsplash.com/photo-1573496359142-b8d87734a5a2?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=256&q=80',
  lastMessage: "I've sent you the interior design concepts for your review.",
  timestamp: 'Yesterday',
  unread: 1,
  isAgent: false,
  isOnline: false
}, {
  id: 4,
  name: 'DHL Express',
  avatar: 'https://images.unsplash.com/photo-1519085360753-af0119f7cbe7?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=256&q=80',
  lastMessage: 'Your package with property documents is in transit.',
  timestamp: 'Monday',
  unread: 0,
  isAgent: false,
  isOnline: true
}];
// Mock messages for the first conversation
const mockMessages = [{
  id: 1,
  sender: 'Victoria Estates',
  content: 'Hello! Thank you for your interest in our Lekki Phase 1 property.',
  timestamp: '10:00 AM',
  isMe: false
}, {
  id: 2,
  sender: 'Me',
  content: "Hi, I'm interested in purchasing the 3-bedroom apartment in Lekki. Can you tell me more about the property?",
  timestamp: '10:05 AM',
  isMe: true
}, {
  id: 3,
  sender: 'Victoria Estates',
  content: 'Of course! The property is a 3-bedroom luxury apartment with ocean views. It features modern finishes, a fully fitted kitchen, and 24/7 power supply. The complex includes amenities such as a swimming pool, gym, and round-the-clock security.',
  timestamp: '10:10 AM',
  isMe: false
}, {
  id: 4,
  sender: 'Victoria Estates',
  content: 'Here are some additional photos of the property:',
  timestamp: '10:12 AM',
  isMe: false,
  attachments: [{
    type: 'image',
    url: 'https://images.unsplash.com/photo-1613553507747-5f8d62ad5904?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1470&q=80'
  }, {
    type: 'image',
    url: 'https://images.unsplash.com/photo-1600210492493-0946911123ea?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1074&q=80'
  }]
}, {
  id: 5,
  sender: 'Me',
  content: "These look great! What's the price and payment process?",
  timestamp: '10:18 AM',
  isMe: true
}, {
  id: 6,
  sender: 'Victoria Estates',
  content: "The price is ₦75,000,000. For payment, you can use our secure escrow system. We'll guide you through the verification process and legal checks before finalizing the transaction.",
  timestamp: '10:20 AM',
  isMe: false
}, {
  id: 7,
  sender: 'Victoria Estates',
  content: "I've attached the property brochure with all details and floor plans for your review.",
  timestamp: '10:23 AM',
  isMe: false,
  attachments: [{
    type: 'file',
    name: 'Lekki_Property_Brochure.pdf',
    size: '2.4 MB'
  }]
}];
const Chat = () => {
  const [activeConversation, setActiveConversation] = useState(conversations[0]);
  const [message, setMessage] = useState('');
  const [chatMessages, setChatMessages] = useState(mockMessages);
  const sendMessage = (e: React.FormEvent) => {
    e.preventDefault();
    if (message.trim()) {
      const newMessage = {
        id: chatMessages.length + 1,
        sender: 'Me',
        content: message,
        timestamp: new Date().toLocaleTimeString([], {
          hour: '2-digit',
          minute: '2-digit'
        }),
        isMe: true
      };
      setChatMessages([...chatMessages, newMessage]);
      setMessage('');
    }
  };
  return <div className="bg-gray-50 min-h-screen w-full" data-id="element-1020">
      <div className="container mx-auto px-4 py-8" data-id="element-1021">
        <h1 className="text-2xl font-bold text-gray-800 mb-6" data-id="element-1022">Messages</h1>
        <div className="bg-white rounded-lg shadow-sm overflow-hidden" data-id="element-1023">
          <div className="flex h-[calc(80vh-2rem)]" data-id="element-1024">
            {/* Conversation List */}
            <div className="w-full md:w-1/3 lg:w-1/4 border-r" data-id="element-1025">
              <div className="p-4 border-b" data-id="element-1026">
                <div className="relative" data-id="element-1027">
                  <input type="text" placeholder="Search conversations..." className="w-full pl-10 pr-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-green-500" data-id="element-1028" />
                  <SearchIcon className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400" size={18} data-id="element-1029" />
                </div>
              </div>
              <div className="overflow-y-auto h-[calc(80vh-8rem)]" data-id="element-1030">
                {conversations.map(conversation => <div key={conversation.id} className={`p-4 border-b hover:bg-gray-50 cursor-pointer ${activeConversation.id === conversation.id ? 'bg-gray-50' : ''}`} onClick={() => setActiveConversation(conversation)} data-id="element-1031">
                    <div className="flex items-center" data-id="element-1032">
                      <div className="relative mr-3" data-id="element-1033">
                        <img src={conversation.avatar} alt={conversation.name} className="w-12 h-12 rounded-full object-cover" data-id="element-1034" />
                        {conversation.isOnline && <div className="absolute bottom-0 right-0 w-3 h-3 bg-green-500 rounded-full border-2 border-white" data-id="element-1035"></div>}
                      </div>
                      <div className="flex-grow min-w-0" data-id="element-1036">
                        <div className="flex justify-between items-center mb-1" data-id="element-1037">
                          <h3 className="font-medium truncate" data-id="element-1038">
                            {conversation.name}
                          </h3>
                          <span className="text-xs text-gray-500" data-id="element-1039">
                            {conversation.timestamp}
                          </span>
                        </div>
                        <div className="flex justify-between items-center" data-id="element-1040">
                          <p className="text-gray-600 text-sm truncate" data-id="element-1041">
                            {conversation.lastMessage}
                          </p>
                          {conversation.unread > 0 && <span className="bg-green-600 text-white text-xs rounded-full w-5 h-5 flex items-center justify-center" data-id="element-1042">
                              {conversation.unread}
                            </span>}
                        </div>
                      </div>
                    </div>
                  </div>)}
              </div>
            </div>
            {/* Chat Window */}
            <div className="hidden md:flex md:flex-col md:w-2/3 lg:w-3/4" data-id="element-1043">
              {/* Chat Header */}
              <div className="p-4 border-b flex justify-between items-center" data-id="element-1044">
                <div className="flex items-center" data-id="element-1045">
                  <div className="relative mr-3" data-id="element-1046">
                    <img src={activeConversation.avatar} alt={activeConversation.name} className="w-10 h-10 rounded-full object-cover" data-id="element-1047" />
                    {activeConversation.isOnline && <div className="absolute bottom-0 right-0 w-2.5 h-2.5 bg-green-500 rounded-full border-2 border-white" data-id="element-1048"></div>}
                  </div>
                  <div data-id="element-1049">
                    <h3 className="font-medium" data-id="element-1050">{activeConversation.name}</h3>
                    <div className="flex items-center text-xs text-gray-500" data-id="element-1051">
                      {activeConversation.isOnline ? <span className="flex items-center" data-id="element-1052">
                          <span className="w-2 h-2 bg-green-500 rounded-full mr-1" data-id="element-1053"></span>
                          Online
                        </span> : 'Offline'}
                      {activeConversation.isAgent && <span className="flex items-center ml-2" data-id="element-1054">
                          <CheckCircleIcon size={12} className="mr-1 text-green-600" data-id="element-1055" />
                          Verified Agent
                        </span>}
                    </div>
                  </div>
                </div>
                <div className="flex items-center space-x-3" data-id="element-1056">
                  <button className="p-2 text-gray-600 hover:bg-gray-100 rounded-full" data-id="element-1057">
                    <PhoneIcon size={18} data-id="element-1058" />
                  </button>
                  <button className="p-2 text-gray-600 hover:bg-gray-100 rounded-full" data-id="element-1059">
                    <VideoIcon size={18} data-id="element-1060" />
                  </button>
                  <button className="p-2 text-gray-600 hover:bg-gray-100 rounded-full" data-id="element-1061">
                    <MoreHorizontalIcon size={18} data-id="element-1062" />
                  </button>
                </div>
              </div>
              {/* Chat Messages */}
              <div className="flex-grow overflow-y-auto p-4 space-y-4" data-id="element-1063">
                {chatMessages.map(msg => <div key={msg.id} className={`flex ${msg.isMe ? 'justify-end' : 'justify-start'}`} data-id="element-1064">
                    {!msg.isMe && <img src={activeConversation.avatar} alt={activeConversation.name} className="w-8 h-8 rounded-full object-cover mr-2 self-end" data-id="element-1065" />}
                    <div className={`max-w-[70%] ${msg.isMe ? 'order-1' : 'order-2'}`} data-id="element-1066">
                      <div className={`rounded-lg p-3 ${msg.isMe ? 'bg-green-600 text-white' : 'bg-gray-100 text-gray-800'}`} data-id="element-1067">
                        <p data-id="element-1068">{msg.content}</p>
                        {msg.attachments && <div className="mt-2 space-y-2" data-id="element-1069">
                            {msg.attachments.map((attachment, index) => attachment.type === 'image' ? <div key={index} className="rounded-lg overflow-hidden" data-id="element-1070">
                                  <img src={attachment.url} alt="Attachment" className="w-full h-auto max-h-48 object-cover" data-id="element-1071" />
                                </div> : <div key={index} className={`flex items-center p-2 rounded ${msg.isMe ? 'bg-green-700' : 'bg-gray-200'}`} data-id="element-1072">
                                  <FileIcon size={18} className={msg.isMe ? 'text-white' : 'text-gray-600'} data-id="element-1073" />
                                  <div className="ml-2" data-id="element-1074">
                                    <p className={`text-sm font-medium ${msg.isMe ? 'text-white' : 'text-gray-800'}`} data-id="element-1075">
                                      {attachment.name}
                                    </p>
                                    <p className={`text-xs ${msg.isMe ? 'text-green-200' : 'text-gray-600'}`} data-id="element-1076">
                                      {attachment.size}
                                    </p>
                                  </div>
                                </div>)}
                          </div>}
                      </div>
                      <div className={`text-xs text-gray-500 mt-1 ${msg.isMe ? 'text-right' : 'text-left'}`} data-id="element-1077">
                        {msg.timestamp}
                      </div>
                    </div>
                    {msg.isMe && <div className="w-8 h-8 rounded-full bg-gray-300 flex items-center justify-center ml-2 self-end" data-id="element-1078">
                        <UserIcon size={16} className="text-gray-600" data-id="element-1079" />
                      </div>}
                  </div>)}
              </div>
              {/* Chat Input */}
              <div className="p-4 border-t" data-id="element-1080">
                <form onSubmit={sendMessage} className="flex items-center space-x-2" data-id="element-1081">
                  <button type="button" className="p-2 text-gray-600 hover:bg-gray-100 rounded-full" data-id="element-1082">
                    <PaperclipIcon size={20} data-id="element-1083" />
                  </button>
                  <button type="button" className="p-2 text-gray-600 hover:bg-gray-100 rounded-full" data-id="element-1084">
                    <ImageIcon size={20} data-id="element-1085" />
                  </button>
                  <div className="flex-grow" data-id="element-1086">
                    <input type="text" value={message} onChange={e => setMessage(e.target.value)} placeholder="Type a message..." className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-green-500" data-id="element-1087" />
                  </div>
                  <button type="submit" className="p-2 bg-green-600 text-white rounded-full hover:bg-green-700" disabled={!message.trim()} data-id="element-1088">
                    <SendIcon size={20} data-id="element-1089" />
                  </button>
                </form>
              </div>
            </div>
            {/* Mobile: Select a conversation prompt */}
            <div className="flex flex-col items-center justify-center w-full md:hidden" data-id="element-1090">
              <div className="text-center p-8" data-id="element-1091">
                <div className="mx-auto w-16 h-16 bg-gray-200 rounded-full flex items-center justify-center mb-4" data-id="element-1092">
                  <MessageSquareIcon size={32} className="text-gray-500" data-id="element-1093" />
                </div>
                <h3 className="text-xl font-bold mb-2" data-id="element-1094">Your Messages</h3>
                <p className="text-gray-600 mb-4" data-id="element-1095">
                  Select a conversation to start chatting
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>;
};
export default Chat;